import React, { useEffect } from "react";
import { useState, Fragment } from 'react'
import { Link, useSearchParams } from "react-router-dom";
import { NoSymbolIcon, ChevronDownIcon } from "@heroicons/react/24/solid";
import api from "../api";
import Table from "../components/Table";
import SimpleCombobox from "../components/SimpleCombobox"
import Modal from "../components/Modal";
import { Menu, Dialog, Transition } from "@headlessui/react";
import Badge from "../components/Badge";
import { useMediaQuery } from "../hooks/useMediaQuery";
import PatientModuleHeader from "../components/patients/layout/PatientModuleHeader";
import PatientModuleLayout from "../components/patients/layout/PatientModuleLayout";

const columns = [
    { name: 'position', displayText: 'Posición' },
    { name: 'patientName', displayText: 'Paciente' },
    { name: 'govId', displayText: 'C.I.' },
    { name: 'age', displayText: 'Edad' },
    { name: 'doctorName', displayText: 'Doctor' },
    { name: 'showCalled', displayText: 'Fue llamado?' },
    { name: 'showAttended', displayText: 'Fue atendido?' },
]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function TurnsPage() {

    const [sidebarOpen, setSidebarOpen] = useState(false)
    const [sidebarOpenDesktop, setSidebarOpenDesktop] = useState(true)
    const isDesktop = useMediaQuery("(min-width: 1024px)")
    const [doctors, setDoctors] = useState([])
    const [loading, setLoading] = useState(true)
    const [turns, setTurns] = useState([])
    const [open, setOpen] = useState(false)
    const [selectedTurn, setSelectedTurn] = useState(undefined)
    const [selectedDoctor, setSelectedDoctor] = useState(undefined)
    const [filter, setFilter] = useState(undefined)
    const [openConfirmation, setOpenConfirmation] = useState(false)
    const [error, setError] = useState(undefined)
    const [errorMessage, setErrorMessage] = useState(undefined)
    const [today, setToday] = new Date().toISOString().split('T')

    const handleSidebarToggle = () => {
        if (isDesktop) {
            setSidebarOpenDesktop(!sidebarOpenDesktop);
            return;
        }
        setSidebarOpen(true);
    };

    const handleOpen = (value) => {
        setSelectedTurn(value);
        setOpen(true);
    }

    useEffect(() => {
        if (isDesktop) {
            setSidebarOpen(false);
        }
    }, [isDesktop])

    useEffect(() => {
        api.users.getDoctors().then((response) => {
            setDoctors([{ id: 0, name: 'Consulta General' }, 
                ...response.map((element) => {
                    const isLicenciado = element.role.toLowerCase() === "licenciado";
                    const prefix = isLicenciado 
                        ? "Lic."
                        : element.sex.toLowerCase() === "masculino"
                            ? "Dr."
                            : "Dra.";
                    return {
                        name: `${prefix} ${element.firstName} ${element.lastName}`,
                        ...element
                    };
                })
            ]);
            api.turns.getMulti(null, null, null, null, { date: today }).then((turns) => {
                setTurns(
                    turns.map((element) => ({
                        ...element, patientName: element.patient.firstName + ' ' + element.patient.lastName, patient: element.patient.id,
                        doctorName: element.doctor ? element.doctor.firstName + ' ' + element.doctor.lastName : 'Consulta General', govId: element.patient.govId, age: element.patient.age,
                        showCalled: element.called ? 'Sí' : 'No', showAttended: element.attended ? 'Sí' : 'No', doctor: element.doctor ? { ...element.doctor, name: `${element.doctor.sex === 1 ? 'Dr.' : 'Dra.'} ${element.doctor.firstName} ${element.doctor.lastName}` } : { id: 0, name: 'Consulta General' }
                    })))
                setLoading(false)
            })
        })
    }, [])

    useEffect(() => {
        if (filter || filter === 0) {
            api.turns.getMulti(null, null, null, null, { doctor: filter === 0 ? 0 : filter.id, date: today }).then((turns) => {
                setTurns(
                    turns.map((element) => ({
                        ...element, patientName: element.patient.firstName + ' ' + element.patient.lastName, patient: element.patient.id,
                        doctorName: element.doctor ? element.doctor.firstName + ' ' + element.doctor.lastName : 'Consulta General', govId: element.patient.govId, age: element.patient.age,
                        showCalled: element.called ? 'Sí' : 'No', showAttended: element.attended ? 'Sí' : 'No', doctor: element.doctor ? { ...element.doctor, name: `${element.doctor.sex === 1 ? 'Dr.' : 'Dra.'} ${element.doctor.firstName} ${element.doctor.lastName}` } : { id: 0, name: 'Consulta General' }
                    })))
                setLoading(false)
            })
        } else {
            api.turns.getMulti(null, null, null, null, { date: today }).then((turns) => {
                setTurns(
                    turns.map((element) => ({
                        ...element, patientName: element.patient.firstName + ' ' + element.patient.lastName, patient: element.patient.id,
                        doctorName: element.doctor ? element.doctor.firstName + ' ' + element.doctor.lastName : 'Consulta General', govId: element.patient.govId, age: element.patient.age,
                        showCalled: element.called ? 'Sí' : 'No', showAttended: element.attended ? 'Sí' : 'No', doctor: element.doctor ? { ...element.doctor, name: `${element.doctor.sex === 1 ? 'Dr.' : 'Dra.'} ${element.doctor.firstName} ${element.doctor.lastName}` } : { id: 0, name: 'Consulta General' }
                    })))
                setLoading(false)
            })
        }
    }, [filter])

    const handleDoctor = (field, value) => {
        setSelectedTurn({ ...selectedTurn, doctor: value?.id })
    }

    const handleFilter = (field, value) => {
        setSelectedDoctor(value)
    }

    const deleteFilter = () => {
        setSelectedDoctor(undefined)
        setFilter(undefined)
    }

    const saveFilter = () => {
        setFilter(selectedDoctor)
    }

    const handleSubmit = () => {
        setSelectedDoctor(undefined)
        setFilter(undefined)
        api.turns.update(selectedTurn.id, selectedTurn).then(() =>
            api.turns.getMulti().then((turns) => {
                setTurns(
                    turns.map((element) => ({
                        ...element, patientName: element.patient.firstName + ' ' + element.patient.lastName, patient: element.patient.id,
                        doctorName: element.doctor ? element.doctor.firstName + ' ' + element.doctor.lastName : 'Consulta General', govId: element.patient.govId, age: element.patient.age,
                        showCalled: element.called ? 'Sí' : 'No', showAttended: element.attended ? 'Sí' : 'No', doctor: element.doctor ? { ...element.doctor, name: `${element.doctor.sex === 1 ? 'Dr.' : 'Dra.'} ${element.doctor.firstName} ${element.doctor.lastName}` } : { id: 0, name: 'Consulta General' }
                    })))
                setLoading(false)
                setOpenConfirmation(false)
            }))
    }

    const editModal = (
        <>
            < div >
                <div className="text-center">
                    <Dialog.Title as="h3" className="text-lg leading-6 font-semibold text-gray-900">
                        Editar turno
                    </Dialog.Title>
                    <div className="mt-2 w-full">
                        <label htmlFor="password" className="text-sm font-medium text-gray-700">
                            Seleccione el doctor que atenderá al paciente
                        </label>
                        <div className="flex gap-3 w-full justify-center relative rounded-md mt-3">
                            {selectedTurn && <SimpleCombobox value={selectedTurn?.doctor} containerClassName='shadow-sm w-2/3' handleChange={handleDoctor} name="doctor" options={doctors} />}
                        </div>
                        {error && <p className="mt-2 text-sm text-red-600">
                            {error}
                        </p>}
                    </div>
                </div>
            </div >
            <div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                <button
                    type="button"
                    className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary text-base font-medium text-white hover:bg-primary sm:col-start-2 sm:text-sm"
                    onClick={() => (setOpen(false), setOpenConfirmation(true))}
                >
                    Aceptar
                </button>
                <button
                    type="button"
                    className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 sm:mt-0 sm:col-start-1 sm:text-sm dark:bg-gray-900 dark:text-white "
                    onClick={() => (setOpen(false), setSelectedTurn(undefined))}
                >
                    Cancelar
                </button>
            </div>
        </>
    )

    const confirmation = (
        <>
            < div >
                <div className="text-center">
                    <Dialog.Title as="h3" className="text-lg leading-6 font-semibold text-gray-900">
                        Confirmación
                    </Dialog.Title>
                    <div className="mt-2 w-full">
                        <label htmlFor="password" className="text-sm font-medium text-gray-700">
                            ¿Está seguro de que quiere agregar el paciente al turnero?
                        </label>
                        <div className="relative w-2/3 rounded-md mx-auto">
                            {errorMessage && <p className="mt-2 text-sm text-red-600">
                                {errorMessage}
                            </p>}
                        </div>
                    </div>
                </div>
            </div >
            <div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                <button
                    type="button"
                    className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary text-base font-medium text-white hover:bg-primary sm:col-start-2 sm:text-sm"
                    onClick={() => handleSubmit()}
                >
                    Aceptar
                </button>
                <button
                    type="button"
                    className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 sm:mt-0 sm:col-start-1 sm:text-sm dark:bg-gray-900 dark:text-white"
                    onClick={() => (setOpenConfirmation(false), setOpen(true))}
                >
                    Regresar
                </button>
            </div>
        </>
    )

    const pages = [
        { name: 'Turnero', href: '/turns', current: true },
    ]

    return (
        <PatientModuleLayout
            currentScreen="Turnero"
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
            sidebarOpenDesktop={sidebarOpenDesktop}
            loading={loading}
            header={
                <PatientModuleHeader
                    pages={pages}
                    onToggleSidebar={handleSidebarToggle}
                    mobileBackTo="/turns"
                    mobileBackLabel="Turnero"
                />
            }
        >
            <Modal size='sm:max-w-lg w-full' content={editModal} open={open} setOpen={setOpen} />
            <Modal size='sm:max-w-lg w-full' content={confirmation} open={openConfirmation} setOpen={setOpenConfirmation} />
            <div className="bg-slate-100 dark:bg-slate-900">
                <div className="bg-white dark:bg-gray-900 p-4 border-b border-gray-200 dark:border-gray-700">
                    <Menu as="div" className="relative flex justify-start items-center gap-2 text-left">
                        <div>
                            <Menu.Button className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-primary px-3 py-2 text-sm text-white ring-0 outline-0">
                                Doctor
                                <ChevronDownIcon className="-mr-1 h-5 w-5 text-white" aria-hidden="true" />
                            </Menu.Button>
                        </div>
                        <Transition
                            as={Fragment}
                            enter="transition ease-out duration-100"
                            enterFrom="transform opacity-0 scale-95"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-95"
                        >
                            <Menu.Items className="absolute z-10 mt-2 w-64 top-[45px] sm:top-[35px] rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none dark:bg-gray-900 dark:text-white">
                                <div className="py-4 flex flex-col gap-3 px-5">
                                    <SimpleCombobox value={selectedDoctor} handleChange={handleFilter} name='doctor' label='Doctor' options={doctors} />
                                    <div className="flex gap-3">
                                        <button onClick={() => deleteFilter()} className="flex justify-center gap-2 py-2 px-2 w-full border border-[#D1D5DB] rounded-md shadow-sm text-sm font-medium bg-white dark:bg-gray-900 dark:text-white">
                                            Borrar filtro
                                        </button>
                                        <button onClick={() => saveFilter()} className="flex justify-center gap-2 py-2 px-2 w-full border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary">
                                            Aplicar filtro
                                        </button>
                                    </div>
                                </div>
                            </Menu.Items>
                        </Transition>
                    </Menu>
                </div>
                {(filter || filter === 0) &&
                    <div className="p-2">
                        <Badge text={`Doctor: ${filter.name}`} handleDelete={() => deleteFilter()} />
                    </div>
                }
                {turns.length ?
                    <div className="py-6">
                        <div className="px-4 sm:px-6 md:px-8">
                            <Table columns={columns} rows={turns} openModal={handleOpen} />
                        </div>
                    </div>
                    :
                    <div className="flex min-h-[calc(100vh-200px)] items-center justify-center">
                        <div className="text-center">
                            <NoSymbolIcon className="h-12 w-12 mx-auto text-gray-400" aria-hidden="true" />
                            <h3 className="mt-2 text-sm font-semibold text-gray-900 dark:text-white">No se encontraron resultados</h3>
                        </div>
                    </div>
                }
            </div>
        </PatientModuleLayout>
    );
}
